export default class TipoOperacionService{

	constructor($http, baseUrl){
		this.http    = $http;
		this.baseUrl = baseUrl;

		this.routes = {
			"all": '/api/tipo_operacion',
			"id": '/api/tipo_operacion/:id',
			"new": '/api/tipo_operacion',
			'delete': '/api/tipo_operacion/:id'
		};
	}

	getAll(filter){
		let url = this.baseUrl + this.routes.all;
		let config = {
			params : filter
		};
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/tipoOperacionService.js